import {gql} from "@apollo/client";
import {client} from "graphql/client";

// 创建揽收调度员
export const CREATE_ACCOUNT_PICKUP_DISPATCHER = gql`
    mutation CreateAccountPickupDispatcher($input: AccountPickupDispatcherInput!) {
        createAccountPickupDispatcher(input: $input)
    }
`;

// 更新揽收调度员
export const UPDATE_ACCOUNT_PICKUP_DISPATCHER = gql`
    mutation UpdateAccountPickupDispatcher($input: AccountPickupDispatcherInput!) {
        updateAccountPickupDispatcher(input: $input)
    }
`;

export interface AccountPickupDispatcherInput {
    id?: string;
    email?: string;
    countryCode: number;
    phone?: string;
    password?: string;
    name: string;
    avatarStorageToken?: string;
    status: number;
    warehouseId: number;
    role: string;
}

export const createAccountPickupDispatcher = async (input: AccountPickupDispatcherInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: CREATE_ACCOUNT_PICKUP_DISPATCHER,
        variables: {input}
    });
    return data.createAccountPickupDispatcher;
};

export const updateAccountPickupDispatcher = async (input: AccountPickupDispatcherInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: UPDATE_ACCOUNT_PICKUP_DISPATCHER,
        variables: {input}
    });
    return data.updateAccountPickupDispatcher;
}; 